export default {
  options: 'Opciones de importación',
  formatSelection: 'Por favor, para importar el fichero correctamente, seleccione el formato de las facturas que va a importar.',
  format: 'Formato',
  preserveId: 'Importar respetando la serie y número',
  signed: 'Facturas firmadas',
  file: 'Fichero',
  formatTypes: {
    label: 'Formatos',
    text: '{0}: Excel, XML.'
  },
  maxSize: {
    label: 'Tamaño máximo',
    text: '{0}: 10 Mb'
  },
  accept: 'Aceptar',
  cancel: 'Cancelar',
  errors: {
    400: {
      1000: 'El campo formato es obligatorio'
    }
  },
  correct: 'Correcta',
  rejected: 'Repudiada',
  notTreated: 'No Tratada'
}
